import { Avatar, IconButton } from "@mui/material";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { deletePostApi, getPostListApi } from "../../../services/community";
import ModalBox from "../../../components/modal/ModalBox";
import {
  dateFormat,
  formatContent,
  timeFormat,
} from "../../../components/Form";
import BrokenImageIcon from "@mui/icons-material/BrokenImage";
import { catchMessage, elseMessage } from "../../../comman/Message";
import Pagination from "react-js-pagination";
import { useNavigate } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";

const Shares = ({ id }) => {
  const [postList, setPostList] = useState();
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [deleteName, setDeleteName] = useState("");
  // console.log("postList",postList)
  const handleAvatarClick = (postId) => {
    navigate(`/community-circles/view-details/post-Details/${postId}`); // Replace with your target route
  };
  //-----------handle-pagination--------------
  const handlePageChange = (event) => {
    setPage(event);
  };

  const getPostList = async (activePage = page, limit = 9) => {
    setPostList([]);
    try {
      const res = await getPostListApi(id, { page: activePage, limit }); // { page: activePage ,limit}
      if (res?.data?.status === 200) {
        setPostList(res?.data?.data?.communityList || []); //remove 1
        setTotal(res?.data?.data?.total || 0);
      } else {
        elseMessage(res);
        setPostList([]);
      }
    } catch (err) {
      catchMessage(err);
    }
  };
  // ---------open-delete-confirmation-popup-------------
  const deleteHandler = (postId, name) => {
    setDeleteId(postId);
    setDeleteName(name);
    setDeleteModal(true);
  };

  // ---------delete-share-and-its-related-data-------------
  const deletePost = async () => {
    try {
      const res = await deletePostApi(deleteId);
      if (res?.data?.status === 200) {
        toast.success(res?.data?.message);
        setDeleteModal(false);
        setDeleteId("");
        // if last item of the page is removed, move a page back
        const isLastItemOnPage = postList?.length === 1 && page > 1;
        if (isLastItemOnPage) {
          setPage(page - 1);
        } else {
          getPostList(page, 9);
        }
      } else {
        elseMessage(res);
      }
    } catch (err) {
      catchMessage(err);
    }
  };

  useEffect(() => {
    getPostList(page, 9);
  }, [id, page]);
  return (
    <>
      <div className="row mt-3  ">
        {postList && postList.length > 0 ? (
          postList.map(
            (
              {
                _id,
                content,
                name,
                profile,
                userName,
                media,
                createdAt,
                isRefer,
              },
              index
            ) => {
              return (
                <div className="col-4 p-2 " key={index}>
                  <div
                    className={`item_wrap rounded bg-light border p-2 `} // Apply the custom class if isReffer is true
                  >
                    <div className="d-flex justify-content-end">
                      <IconButton
                        title="Delete Share"
                        onClick={(e) => {
                          e.stopPropagation();
                          deleteHandler(_id, name);
                        }}
                      >
                        <DeleteForeverIcon
                          sx={{ color: "red", fontSize: 26 }}
                        />
                      </IconButton>
                    </div>
                    <div
                      className="row cursor_pointer"
                      onClick={() => handleAvatarClick(_id)}
                    >
                      <div className="col-2 mt-2 mb-2">
                        <Avatar
                          src={profile}
                          // onClick={() => setShowImgModal(seller?.nationalIdCardImageUrl ? true : false)}
                        >
                          <InsertPhotoIcon />
                        </Avatar>
                      </div>
                      <div className="col-5 text-start mt-2 mb-2">
                        <b>{name || "N/A"}</b>
                        {isRefer ? (
                          <StarIcon sx={{ color: "#ffc107", fontSize: 30 }} />
                        ) : (
                          ""
                        )}
                        <p>{userName || "N/A"}</p>
                      </div>
                      <div className="col-5 text-end mt-2 mb-2">
                        <p>{dateFormat(createdAt)}</p>
                      </div>
                      <span
                        className="mb-2 text-center"
                        dangerouslySetInnerHTML={{
                          __html: formatContent(content.slice(0, 50) || "N/A"),
                        }}
                      />

                      {/* <p className='mt-2 mb-3'>{content.replace(/#\[(\w+)\]\(undefined\)/g, '#$1').slice(0, 45)}.</p> */}
                    </div>
                    <div>
                      <Avatar
                        className="w-100"
                        variant="rounded"
                        // onClick={() => setShowImgModal(seller?.nationalIdCardImageUrl ? true : false)}
                        src={media?.[0]?.name}
                        onClick={() => handleAvatarClick(_id)}
                        sx={{
                          width: 370,
                          height: 170,
                          borderRadius: 2,
                          borderColor: "#9dc4b4",
                          cursor: "pointer",
                        }}
                      >
                        <InsertPhotoIcon sx={{ fontSize: 100 }} />
                      </Avatar>
                    </div>
                  </div>
                </div>
              );
            }
          )
        ) : (
          <div className="col-4 p-2">
            <div className="item_wrap rounded bg-light border p-2">
              <div className="row">
                <h4 className="mt-2 mb-3 text-center">No Post Found</h4>
              </div>
              <div>
                <Avatar
                  className="w-100"
                  variant="rounded"
                  sx={{
                    width: 370,
                    height: 170,
                    borderRadius: 2,
                    borderColor: "#9dc4b4",
                  }}
                >
                  <BrokenImageIcon sx={{ fontSize: 100 }} />
                </Avatar>
              </div>
            </div>
          </div>
        )}
      </div>
      {total >= 9 ? (
        <div className="Pagination">
          <Pagination
            previousLabel={"previous"}
            nextLabel={"next"}
            activePage={page}
            itemsCountPerPage={9}
            totalItemsCount={total}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            itemClass={"page-item"}
            linkClass={"page-link"}
          />
        </div>
      ) : null}
      {/* --------delete-share-confirmation-modal---------- */}
      <ModalBox
        status={deleteModal}
        onClose={() => setDeleteModal(false)}
        title="Delete Share"
        description={
          <span>
            Do you want to delete this share
            {deleteName ? (
              <>
                {" "}
                of <strong>{deleteName}</strong>
              </>
            ) : (
              ""
            )}
            ? All data related to this share will also be deleted.
          </span>
        }
        action={deletePost}
      />
    </>
  );
};

export default Shares;
